<h2 class="cald-heading">{{'Admin.Responsive.VersionComparation' | translate}}</h2>
<div class="cald_content">
  <table class="content-holder">
    <tr>
      <td align="center">
        <span class="big-text">{{originalObject.title}}</span>
      </td>
      <td align="center">
        <span class="big-text">{{compareObject.title}}</span>
      </td>
    </tr>
    <tr>
      <td colspan="2">
        <div id="codeMirrorContainer" class=""></div>
      </td>
    </tr>
  </table>
</div>